import { useEffect, useState, useRef } from "react"
import { Bell, Terminal, Settings2 } from "lucide-react"

function useClock() {
  const [time, setTime] = useState(() => new Date())
  useEffect(() => {
    const id = setInterval(() => setTime(new Date()), 1000)
    return () => clearInterval(id)
  }, [])
  return time
}

function useSessionTimer() {
  const startRef = useRef(Date.now())
  const [elapsed, setElapsed] = useState(0)
  useEffect(() => {
    const id = setInterval(() => setElapsed(Math.floor((Date.now() - startRef.current) / 1000)), 1000)
    return () => clearInterval(id)
  }, [])
  const hh = String(Math.floor(elapsed / 3600)).padStart(2, "0")
  const mm = String(Math.floor((elapsed % 3600) / 60)).padStart(2, "0")
  const ss = String(elapsed % 60).padStart(2, "0")
  return `${hh}:${mm}:${ss}`
}

interface CtrlTopbarProps {
  pageName?: string
  pageDescription?: string
}

export function CtrlTopbar({ pageName, pageDescription }: CtrlTopbarProps) {
  const now = useClock()
  const session = useSessionTimer()

  const pad = (v: number) => String(v).padStart(2, "0")
  const hh = pad(now.getHours())
  const mm = pad(now.getMinutes())
  const ss = pad(now.getSeconds())
  const dateStr = `${now.getFullYear()}.${pad(now.getMonth() + 1)}.${pad(now.getDate())}`

  const label = pageName ? pageName.toUpperCase() : "DASHBOARD"
  const desc = pageDescription ?? "sistema carregado. todos os módulos online."

  return (
    <>
      <div className="ctrl-topbar">
        {/* Title */}
        <div className="ctrl-topbar__title-wrap">
          <div className="ctrl-topbar__label">// controle</div>
          <div className="ctrl-topbar__title">{label}</div>
        </div>

        <div className="ctrl-topbar__spacer" />

        {/* Icon buttons */}
        <button className="ctrl-topbar__icon-btn" title="Notificações">
          <Bell className="w-[14px] h-[14px]" />
          <span className="ctrl-topbar__notif-dot" />
        </button>

        <button className="ctrl-topbar__icon-btn" title="Terminal">
          <Terminal className="w-[14px] h-[14px]" />
        </button>

        <button className="ctrl-topbar__icon-btn" title="Configurações">
          <Settings2 className="w-[14px] h-[14px]" />
        </button>

        {/* Clock */}
        <div className="ctrl-topbar__clock-wrap">
          <div className="ctrl-topbar__clock">{hh}:{mm}:{ss}</div>
          <div className="ctrl-topbar__date">{dateStr}</div>
        </div>
      </div>

      {/* Status bar */}
      <div className="ctrl-statusbar">
        <div className="ctrl-statusbar__left">
          <span className="ctrl-statusbar__page-title">Visão Geral do Sistema</span>
          <span className="ctrl-statusbar__desc">&gt; {desc}</span>
        </div>
        <div className="ctrl-statusbar__right">
          <div className="ctrl-statusbar__stat">
            <span className="ctrl-statusbar__stat-label">SESSÃO</span>
            <span className="ctrl-statusbar__stat-value">{session}</span>
          </div>
          <div className="ctrl-statusbar__stat">
            <span className="ctrl-statusbar__stat-label">SEDE</span>
            <span className="ctrl-statusbar__stat-value">BR-SE-1</span>
          </div>
          <div className="ctrl-statusbar__stat">
            <span className="ctrl-statusbar__stat-label">STATUS</span>
            <span className="ctrl-statusbar__stat-value ctrl-statusbar__stat-value--online">ONLINE</span>
          </div>
        </div>
      </div>
    </>
  )
}
